import type { Role } from "@/features/auth/types";

const roleRank: Record<Role, number> = {
  DEVELOPER: 4,
  OWNER: 3,
  ADMIN: 2,
  EDITOR: 1,
};

export function roleAtLeast(actual: Role | undefined, minimum: Role): boolean {
  return actual ? roleRank[actual] >= roleRank[minimum] : false;
}
